import React, {useEffect} from "react";
import appStoreIcon from "./../../assets/images/Download_on_the_App_Store_Badge_RU_RGB_blk_100317.svg";
import {AppDescriptions} from "./consts";
import './onlyAssist/customPage/only-assist_custom_page.scss';
import {ServicesNameType} from "../../dto/appdescriptions.dto";
import {Helmet} from "react-helmet";
import image from "./onlyAssist/images/Pearl.png";

const AppDownloadAuthContainer: React.FC<{
    name: ServicesNameType
}> = ({name}) => {
    useEffect(() => {
        document.body.style.backgroundColor = '#ECECEC';
    }, []);

    return <div>
        <Helmet>
            <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
            <meta name="google-site-verification" content="5IklxOr5FpR1Vfmz7QtJntLkEcMNjJ3YG_KC6mfm9nk" />
            {AppDescriptions[name].metaTags.map((tag: any) => tag)}
            <script>
                {`(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){

                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),

                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)

            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

                ga('create', 'UA-59168148-1', 'auto');

                ga('send', 'pageview');`}
            </script>
        </Helmet>
        <div className="ac-root">
            <section className="ac-hero">
                <div className="ac-hero-bg-art">
                    <div className="ac-hero-bg-glow" />
                    <div className="ac-hero-bg-orb">
                        <div className="ac-orb">
                            <div className="ac-orb-body">
                                <img className="ac-hero-image" src={image} alt='magic background'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ac-hero-grid ac-hero-grid-solo">
                    <div className="ac-hero-copy">
                        <h1 className="ac-hero-h1">
                            <span className="ac-hero-h1-line">Спасибо за</span>
                            <span className="ac-hero-h1-line ac-hero-mark">регистрацию</span>
                        </h1>
                        <p className="ac-hero-sub">
                            Теперь вы можете скачать наше приложение и&nbsp;войти по&nbsp;указанному вами номеру телефона. Будем ждать
                            ваши запросы 😊
                        </p>
                    </div>
                </div>
            </section>
            <section className="ac-hero">
                <div className="">
                    <div className="ac-step-body">
                        <p className="ac-step-p">
                            <div className="ac-store-row">
                                <a
                                    className="ac-store-btn"
                                    href='https://apps.apple.com/ru/app/konsierge/id946404265'
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={appStoreIcon} alt='app store'/>
                                </a>
                            </div>
                        </p>
                    </div>
                </div>
            </section>
            <section className="ac-contact">
                <div className="ac-contact-inner">
                    <div className="ac-contact-emoji">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <circle cx="20" cy="20" r="18" fill="#FFD24A" />
                            <circle cx="14" cy="17" r="2" fill="#1B1B1D" />
                            <circle cx="26" cy="17" r="2" fill="#1B1B1D" />
                            <path d="M13 24c2 3 5 4.5 7 4.5S25 27 27 24" stroke="#1B1B1D" strokeWidth="2.4" strokeLinecap="round" fill="none" />
                        </svg>
                    </div>
                    <div className="ac-contact-copy">
                        <div className="ac-contact-h">Остались вопросы?</div>
                        <div className="ac-contact-sub">Мы на&nbsp;связи&nbsp;— в&nbsp;любой момент</div>
                    </div>
                    <div className="ac-contact-actions">
                        <a className="ac-contact-pill" href="tel:88005053139">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path d="M5 4h4l2 5-3 2c1 3 3 5 6 6l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" strokeWidth="2" />
                            </svg>
                            <span>8&nbsp;800&nbsp;505&nbsp;31&nbsp;39</span>
                        </a>
                        <a className="ac-contact-pill" href="mailto:ab@knsrg.ru">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <rect x="3" y="5" width="18" height="14" rx="2" strokeWidth="2" />
                                <path d="m3 7 9 6 9-6" strokeWidth="2" />
                            </svg>
                            <span>ab@knsrg.ru</span>
                        </a>
                    </div>
                </div>
            </section>
        </div>
    </div>
};

export default AppDownloadAuthContainer;
